export default __webpack_public_path__ + "static/media/logohotel.11afe9b4.png";